import React, { useState } from "react";
import Map from "../Components/Map"; // Google Maps
import LeafletMap from "../Components/LeafletMap"; // OpenStreetMap
import SmartMap from "../Components/SmartMap"; // Smart selector

const MapComparisonPage = () => {
  const [selectedLocation, setSelectedLocation] = useState("both");

  const mapFeatures = {
    google: {
      name: "Google Maps",
      pros: [
        "המוכר ביותר למשתמשים",
        "נתונים מדויקים",
        "אינטגרציה טובה עם שירותי Google",
        "תמיכה טובה בעברית",
      ],
      cons: [
        "עלות גבוהה לשימוש מסחרי",
        "הגבלות על התאמה אישית",
        "תלות בשירותי Google",
      ],
      cost: "💰 $7 לכל 1000 טעינות מפה",
      performance: "⚡⚡⚡⚡",
      customization: "🎨🎨🎨",
      maintenance: "🔧🔧🔧🔧",
    },
    leaflet: {
      name: "OpenStreetMap + Leaflet",
      pros: [
        "חינמי לחלוטין!",
        "קוד פתוח",
        "התאמה אישית מלאה",
        "ביצועים מעולים",
        "קהילה גדולה ותמיכה",
      ],
      cons: [
        "פחות מוכר למשתמשים",
        "צריך יותר הגדרות ראשוניות",
        "עיצוב פחות מלוטש כברירת מחדל",
      ],
      cost: "✅ חינמי לחלוטין",
      performance: "⚡⚡⚡⚡⚡",
      customization: "🎨🎨🎨🎨🎨",
      maintenance: "🔧🔧🔧",
    },
    smart: {
      name: "Smart Map (מומלץ!)",
      pros: [
        "משלב את כל היתרונות",
        "גיבוי אוטומטי במקרה של בעיות",
        "בחירה דינמית של ספק",
        "חסכוני ומתקדם",
      ],
      cons: ["מורכב יותר בהתחלה"],
      cost: "💡 חכם - מתחיל חינם",
      performance: "⚡⚡⚡⚡⚡",
      customization: "🎨🎨🎨🎨🎨",
      maintenance: "🔧🔧🔧🔧🔧",
    },
  };

  return (
    <div
      style={{
        padding: "40px 20px",
        maxWidth: "1400px",
        margin: "0 auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        direction: "rtl",
      }}
    >
      {/* Header */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "40px",
        }}
      >
        <h1
          style={{
            color: "#01727a",
            fontSize: "32px",
            marginBottom: "10px",
          }}
        >
          השוואת פתרונות מפה למרפאה
        </h1>
        <p
          style={{
            color: "#666",
            fontSize: "18px",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          השוואה מקיפה בין פתרונות המפה השונים - עלות, ביצועים ועיצוב
        </p>
      </div>

      {/* Location Selector */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "30px",
        }}
      >
        <label
          style={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#01727a",
            marginLeft: "15px",
          }}
        >
          בחר מיקום:
        </label>
        <select
          value={selectedLocation}
          onChange={(e) => setSelectedLocation(e.target.value)}
          style={{
            padding: "8px 15px",
            borderRadius: "20px",
            border: "2px solid #01727a",
            fontSize: "14px",
            background: "white",
            cursor: "pointer",
          }}
        >
          <option value="both">שתי המרפאות</option>
          <option value="herzliya">מרפאת הרצליה</option>
          <option value="beersheba">מרפאת באר שבע</option>
        </select>
      </div>

      {/* Maps Comparison Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
          gap: "30px",
          marginBottom: "50px",
        }}
      >
        {/* Google Maps */}
        <div
          style={{
            background: "#f8f9fa",
            borderRadius: "20px",
            padding: "20px",
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h3
            style={{
              color: "#01727a",
              textAlign: "center",
              marginBottom: "15px",
            }}
          >
            Google Maps (נוכחי)
          </h3>
          <Map location={selectedLocation} height="300px" />
        </div>

        {/* OpenStreetMap with Leaflet */}
        <div
          style={{
            background: "#f0f8ff",
            borderRadius: "20px",
            padding: "20px",
            boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h3
            style={{
              color: "#01727a",
              textAlign: "center",
              marginBottom: "15px",
            }}
          >
            OpenStreetMap (חינמי!)
          </h3>
          <LeafletMap location={selectedLocation} height="300px" />
        </div>

        {/* Smart Map */}
        <div
          style={{
            background: "linear-gradient(135deg, #e8f5e8 0%, #f0f8ff 100%)",
            borderRadius: "20px",
            padding: "20px",
            boxShadow: "0 8px 25px rgba(1, 114, 122, 0.2)",
            border: "2px solid #01727a",
          }}
        >
          <h3
            style={{
              color: "#01727a",
              textAlign: "center",
              marginBottom: "15px",
            }}
          >
            Smart Map (מומלץ!) 🌟
          </h3>
          <SmartMap location={selectedLocation} height="300px" />
        </div>
      </div>

      {/* Features Comparison Table */}
      <div
        style={{
          background: "white",
          borderRadius: "20px",
          padding: "30px",
          boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
          marginBottom: "40px",
        }}
      >
        <h2
          style={{
            color: "#01727a",
            textAlign: "center",
            marginBottom: "30px",
          }}
        >
          השוואת תכונות מפורטת
        </h2>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "25px",
          }}
        >
          {Object.entries(mapFeatures).map(([key, feature]) => (
            <div
              key={key}
              style={{
                background:
                  key === "smart"
                    ? "linear-gradient(135deg, #e8f5e8 0%, #f0f8ff 100%)"
                    : "#f8f9fa",
                padding: "20px",
                borderRadius: "15px",
                border:
                  key === "smart" ? "2px solid #01727a" : "1px solid #e0e0e0",
              }}
            >
              <h3
                style={{
                  color: "#01727a",
                  fontSize: "18px",
                  marginBottom: "15px",
                  textAlign: "center",
                }}
              >
                {feature.name}
                {key === "smart" && " 🏆"}
              </h3>

              <div style={{ marginBottom: "15px" }}>
                <div
                  style={{
                    background: "#01727a",
                    color: "white",
                    padding: "8px 12px",
                    borderRadius: "20px",
                    textAlign: "center",
                    fontSize: "14px",
                    fontWeight: "600",
                    marginBottom: "10px",
                  }}
                >
                  {feature.cost}
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "8px",
                    fontSize: "12px",
                  }}
                >
                  <div>ביצועים: {feature.performance}</div>
                  <div>התאמה: {feature.customization}</div>
                </div>
              </div>

              <div style={{ marginBottom: "15px" }}>
                <h4
                  style={{
                    color: "#28a745",
                    fontSize: "14px",
                    marginBottom: "8px",
                  }}
                >
                  ✅ יתרונות:
                </h4>
                <ul
                  style={{
                    fontSize: "13px",
                    lineHeight: "1.5",
                    paddingRight: "15px",
                    margin: 0,
                  }}
                >
                  {feature.pros.map((pro, index) => (
                    <li key={index}>{pro}</li>
                  ))}
                </ul>
              </div>

              <div>
                <h4
                  style={{
                    color: "#dc3545",
                    fontSize: "14px",
                    marginBottom: "8px",
                  }}
                >
                  ⚠️ חסרונות:
                </h4>
                <ul
                  style={{
                    fontSize: "13px",
                    lineHeight: "1.5",
                    paddingRight: "15px",
                    margin: 0,
                  }}
                >
                  {feature.cons.map((con, index) => (
                    <li key={index}>{con}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Recommendation */}
      <div
        style={{
          background: "linear-gradient(135deg, #01727a 0%, #0288a3 100%)",
          color: "white",
          padding: "30px",
          borderRadius: "20px",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "24px",
            marginBottom: "15px",
          }}
        >
          📋 ההמלצה שלי
        </h2>
        <p
          style={{
            fontSize: "16px",
            lineHeight: "1.6",
            maxWidth: "800px",
            margin: "0 auto",
          }}
        >
          <strong>OpenStreetMap עם Leaflet</strong> הוא הפתרון המושלם למרפאה שלך
          - חינמי לחלוטין, מהיר, יפה ומותאם אישית לעיצוב הרפואי. SmartMap מוסיף
          שכבת אבטחה עם גיבוי אוטומטי.
          <br />
          <br />
          💰 <strong>חיסכון:</strong> מאות דולרים בשנה • 🎨{" "}
          <strong>עיצוב:</strong> מותאם למרפאה • ⚡ <strong>מהירות:</strong>{" "}
          טעינה מהירה יותר
        </p>
      </div>
    </div>
  );
};

export default MapComparisonPage;
